import { create } from 'zustand';
import { API_URL } from '../../../utils/constants';
import api from '../../../store/api';
const message = (e, fallback) => e.response?.data?.msg || fallback;
let configRequest = 0;
let agendaRequest = 0;
const useCitasStore = create((set, get) => ({
  config: null, citas: [], configLoading: true, appointmentsLoading: false, configError: '', agendaError: '',
  fetchConfig: async (ownerId) => {
    const request = ++configRequest;
    set({ config: null, configLoading: true, configError: '' });
    try {
      const { data } = await api.get(`${API_URL}/negocio/config/${encodeURIComponent(ownerId)}`);
      if (request === configRequest) set({ config: data, configLoading: false });
    } catch (e) { if (request === configRequest) set({ configLoading: false, configError: message(e, 'No pudimos cargar este negocio. Revisa el enlace e intenta de nuevo.') }); }
  },
  fetchMyConfig: async () => {
    const request = ++configRequest;
    set({ config: null, configLoading: true, configError: '' });
    try {
      const { data } = await api.get(`${API_URL}/negocio/mi-config`);
      if (request === configRequest) set({ config: data, configLoading: false });
    } catch (e) { if (request === configRequest) set({ configLoading: false, configError: message(e, 'No pudimos cargar tu configuración.') }); }
  },
  fetchCitas: async role => {
    const request = ++agendaRequest;
    set({ citas: [], appointmentsLoading: true, agendaError: '' });
    try {
      const { data } = await api.get(`${API_URL}/citas/${role === 'owner' ? 'agenda' : 'mis-citas'}`);
      if (request === agendaRequest) set({ citas: data, appointmentsLoading: false });
    } catch (e) { if (request === agendaRequest) set({ appointmentsLoading: false, agendaError: message(e, 'No pudimos cargar las citas. Intenta de nuevo.') }); }
  },
  solicitarCita: async payload => {
    try {
      const { data } = await api.post(`${API_URL}/citas/solicitar`, payload);
      set(state => ({ citas: [data, ...state.citas] }));
      return { success: true };
    } catch (e) { return { success: false, error: message(e, 'No se pudo enviar la solicitud.') }; }
  },
  cancelarPropiaCita: async id => {
    try {
      const { data } = await api.put(`${API_URL}/citas/cancelar/${id}`, {});
      set(state => ({ citas: state.citas.map(c => c._id === id ? data : c) }));
      return { success: true };
    } catch (e) { return { success: false, error: message(e, 'No se pudo cancelar la cita.') }; }
  },
  actualizarConfig: async payload => {
    try {
      const { data } = await api.post(`${API_URL}/negocio/config`, payload);
      set({ config: data }); return { success: true };
    } catch (e) { return { success: false, error: message(e, 'No se pudo guardar la configuración.') }; }
  },
  gestionarEstadoCita: async (id, status) => {
    try {
      const current = get().citas.find(c => c._id === id);
      const { data } = await api.patch(`${API_URL}/citas/manage/${id}`, { status, expectedStatus: current?.status });
      set(state => ({ citas: state.citas.map(c => c._id === id ? data : c) }));
      return { success: true };
    } catch (e) { return { success: false, error: message(e, 'No se pudo cambiar el estado. Actualiza la agenda.') }; }
  },
}));
export default useCitasStore;
